module.exports = __webpack_public_path__ + "static/img/isotr.cdb1b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/isotr.png
// module id = vP24
// module chunks = 2